@if (loading()) {
  <app-loading></app-loading>
} @else {
  <router-outlet></router-outlet>
}
